import React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { withRouter } from "react-router";
import { Trans } from "react-i18next";

import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import "./Login.css";

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        };
    }

    componentDidMount() {

    }

    render() {
        return (
            <div
                className="background"
                style={{ display: "flex", flexDirection: "column" }}
            >
                <NavBar />
                <Container maxWidth="sm" style={{ marginTop: "64px", flex: "1" }}>
                    <Typography variant="h5" gutterBottom className="loginTitle">
                        <Trans>VideoViews Pricing</Trans>
                    </Typography>

                    <div className="queryTitle" style={{ marginBottom: '0px' }}><Trans>Free Tier</Trans></div>
                    <p className="loginText" style={{ margin: '4px 0 16px' }}>
                        <Trans>1 VideoViews Credit is provided for free upon registration. 1 Credit provides AI Video Content Analysis for 1 hour of video content.</Trans>
                    </p>

                    <div className="queryTitle" style={{ marginBottom: '0px' }}><Trans>Video Analysis</Trans></div>
                    <p className="loginText" style={{ margin: '4px 0 16px' }}>
                        <Trans>$5 USD per VideoViews Credit, 1 Credit provides AI Video Content Analysis for 1 hour of video content.</Trans>
                    </p>

                    <div className="queryTitle" style={{ marginBottom: '0px' }}><Trans>Data Storage and Access</Trans></div>
                    <p className="loginText" style={{ margin: '4px 0 16px' }}>
                        <Trans>$10 USD per month + $0.50 USD per hour of video content after 20 hours. <br />This allows you to view the content analysis result and search for content in your videos.</Trans>
                    </p>

                </Container>
                <Footer></Footer>
            </div>
        );
    }
}

export default withRouter(Index);
